import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=04b74fbe&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=04b74fbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b74fbe",
  null
  
)

export default component.exports